import ROUTES from 'routes';
import {getTimezoneLabel} from 'helpers/date';
import {NotificationMethodEnum} from 'types/notifications';

// Single source of truth for the four viewer tabs; drives the tab bar,
// the header env/region switcher, and the details-page back navigation.
export const VIEWER_TABS = [
    {key: 'email-logs', label: 'Email Logs', route: ROUTES.notificationViewerEmailLogs, method: NotificationMethodEnum.email},
    {key: 'mobile-push', label: 'Mobile Push', route: ROUTES.notificationViewerMobilePush, method: NotificationMethodEnum.mobilePush},
    {key: 'slack', label: 'Slack', route: ROUTES.notificationViewerSlack, method: NotificationMethodEnum.slack},
    {key: 'teams', label: 'Teams', route: ROUTES.notificationViewerTeams, method: NotificationMethodEnum.teams},
];

export const RECIPIENTS_COLUMN = {
    field: 'recipients',
    name: "Recipients",
    sortable: false,
};

export const TENANT_ID_COLUMN = {
    field: 'tenantId',
    name: "Tenant Id",
    sortable: false,
    colspan: 5,
    inline: true,
};

export const SENDER_EMAIL_COLUMN = {
    field: 'senderEmail',
    name: "Sender Email",
    sortable: false,
};

export const SENDER_NAME_COLUMN = {
    field: 'senderName',
    name: "Sender Name",
    sortable: false,
};

export const SUBJECT_COLUMN = {
    field: 'subject',
    name: "Subject",
    sortable: false,
};

export const TITLE_COLUMN = {
    field: 'title',
    name: "Title",
    sortable: false,
};

export const NOTIFICATION_METHOD_COLUMN = {
    field: 'notificationMethod',
    name: "Method",
    sortable: false,
};

const timezoneLabel = getTimezoneLabel();

export const CREATED_COLUMN = {
    field: 'created',
    name: timezoneLabel ? `Created (${timezoneLabel})` : "Created",
    sortable: false,
    inline: true,
};

export const STATUS = {
    field: 'status',
    name: "Status",
    sortable: false,
};

export const ACTIONS_COLUMN = {
    field: 'actions',
    name: "",
    sortable: false,
    inline: true,
};
